import { Constants } from '@constants';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { Label } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { ChooseAmountInputWithSlider } from '../../../ui/ChooseAmountInputWithSlider/ChooseAmountInputWithSlider';

export const ChooseAmount = ({
    selectedAmount,
    setSelectedAmount,
    maxAmount
}: {
    selectedAmount: number | null;
    setSelectedAmount: (amount: number) => void;
    maxAmount: number;
}) => {
    return (
        <ChooseAmountInputWithSlider
            label={
                <Label htmlFor="choose-amount">
                    <FormattedMessage
                        id="_.rcf_approved_view.choose_amount_label"
                        defaultMessage="What amount would you like to withdraw today?"
                    />
                </Label>
            }
            description={
                <FormattedMessage
                    id="_.rcf_approved_view.choose_amount_description"
                    defaultMessage="Min. {minAmount} is required to activate your credit line."
                    values={{
                        minAmount: (
                            <FormattedCurrency
                                value={Constants.MIN_DRAW_DOWN_AMOUNT}
                            />
                        )
                    }}
                />
            }
            maxAmount={maxAmount}
            selectedAmount={selectedAmount}
            onChange={(value) => setSelectedAmount(value)}
        />
    );
};
